// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"fcc6d974","121":"c77b4846","318":"378e3330","347":"a4956582","440":"24773518","443":"cb278a51","447":"c71b0fd5","455":"f200ae70","547":"a84fb941","734":"be66a45b","820":"cc96cb4d","946":"0dd1ed57"}[chunkId] + ".chunk.js";
};